module.exports = __webpack_public_path__ + "static/img/ri-user-3-line.304845d7.svg";